import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const FieldIssueWizardRoute: RouteType = {
  name: "FieldIssueWizard",
  path: "/workflows/field-issue",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Field Issue Creation",
      component: () => import("./FieldIssueWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./FieldIssueWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const fieldActivityIssuesStore = rootStore.fieldActivityIssuesStore as ServiceStore;
      const jobStore = rootStore.jobStore as ServiceStore;
      const panelStore = rootStore.panelStore as ServiceStore;
      const userStore = rootStore.userStore as ServiceStore;
      const teamStore = rootStore.teamStore as ServiceStore;

      await Promise.all([
        fieldActivityIssuesStore?.find(),
        jobStore?.find(),
        panelStore?.find(),
        userStore?.find(),
        teamStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for field issue:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    const store = (rootStore as any).fieldIssueWizardStore;
    store?.reset();
  },
};

export default FieldIssueWizardRoute;